module.exports = __webpack_public_path__ + "img/cheng.eb72a95c.png";